import {QueryCache, QueryClient} from '@tanstack/react-query';
import {getDefaultStore} from 'jotai';

import {HttpError} from '@services/utils';
import {logoutAtom} from '@atoms/auth';

const store = getDefaultStore();

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      /* 401 не повторяем: токен от повтора не оживёт, а лишний
         round-trip оттягивает логаут — пользователь всё это время
         смотрит на пустой интерфейс. */
      retry: (failureCount, err) => {
        if (err instanceof HttpError && (err.status === 401 || err.status === 403)) return false;
        return failureCount < 1;
      },
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
  queryCache: new QueryCache({
    onError: (err) => {
      if (err instanceof HttpError && err.status === 401) {
        store.set(logoutAtom);
        // Сессия протухла — кэш от неё больше не действителен.
        // Откладываем: чистить кэш изнутри его же обработчика нельзя.
        setTimeout(() => queryClient.clear(), 0);
      }
    },
  }),
});
